import React from 'react';

import './ModalTextInputItem.scss';

export const ModalTextInputItem = ({ children }) => {
  return (
    <div styleName="modal-text-item">
      {children}
    </div>
  );
};

export default ModalTextInputItem;
